import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {EnrollmentModel} from "../../models/enrollment.model";
import {EnrollmentType} from "../../enums/enrollment-type.enum";

@Injectable({
  providedIn: 'root'
})
export class EnrollmentService {
  private baseUrl = `${environment.apiUrl}/enrollment`;

  constructor(private http: HttpClient) { }

  getEnrollmentById(id: number): Observable<EnrollmentModel> {
    return this.http.get<EnrollmentModel>(`${this.baseUrl}/${id}`);
  }

  updateEnrollment(model: EnrollmentModel): Observable<void> {
    switch (model.enrollmentType) {
      case EnrollmentType.INDIVIDUAL_OWNER:
        return this.updateIndividualOwner(model);
      case EnrollmentType.PROPERTY_MANAGEMENT:
        return this.updatePropertyManagement(model);
      case EnrollmentType.INDIVIDUAL_BED:
        return this.updateIndividualBed(model);
      default:
        return new Observable<void>((observer) => {
          observer.error("Enrollment type not supported.");
          observer.complete();
        })
    }
  }

  updateIndividualOwner(model: EnrollmentModel): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/updateOwnerEnrollment`, model);
  }

  updatePropertyManagement(model: EnrollmentModel): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/updatePropertyEnrollment`, model);
  }

  updateIndividualBed(model: EnrollmentModel): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/updateHotelMotelEnrollment`, model);
  }

  /** Save staff edits on an open enrollment without approving/declining; no email. */
  saveForReview(model: EnrollmentModel): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${model.id}/save`, model);
  }

  /**
   * {@code link}: share the new property with an existing one (spec §8) as part of approval.
   * {@code linkWarnings}: why the requested link was NOT applied (empty = linked / none requested).
   */
  approveEnrollment(model: EnrollmentModel, link?: { existingPropertyId: number; newIsHome: boolean } | null):
      Observable<{ linkWarnings?: string[] } | null> {
    const params: any = link ? { shareWithPropertyId: link.existingPropertyId, newPropertyIsHome: link.newIsHome } : {};
    return this.http.put<{ linkWarnings?: string[] } | null>(`${this.baseUrl}/${model.id}/approve`, model, { params });
  }
}
